export const CategoriesGA = {
  CLIQUE: 'click',
};

export const ActionsGA = {
  LOGIN: 'login',
  FOOTER: 'footer',
  HEADER: 'header',
  MOVIMENTACAO: 'movimentacao',
  UPLOAD: 'upload',
  NOVAS_OPERACOES: 'novas-operacoes',
  REL_CONTABEIS: 'relatorios-contabeis',
  REL_GERAIS: 'relatorios-gerais',
  EXTRATOS: 'extratos',
  XML: 'xml',
  CAR_DIARIA: 'carteira-diaria',
  OPERADOR_CONTA: 'operadores-contas',
  MOVIMENTACAO_ETF: ' ',
  INVESTIDOR_ETF: 'investidor-etf',
  NOVAS_OPERACOES_FUNDOS: 'novas-operacoes-fundos',
  NOVAS_OPERACOES_CARTEIRAS: 'novas-operacoes-carteiras',
};
  